import { useEffect } from 'react';

// Injects the fonts, base resets, and keyframe animations the prototype relies on.
// Scoped to a single <style> + <link> tag that is added once and removed on unmount.
// The reveal/hover/animation classes it defines are consumed by useReveal, useMagnetic,
// and the various pages.

const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=IBM+Plex+Sans:wght@400;500;600&family=JetBrains+Mono:wght@400;500;700&display=swap';

const CSS = `
  .vt-scope *{box-sizing:border-box}
  .vt-scope a{color:#4d8dff;text-decoration:none}
  .vt-scope a:hover{color:#7fb0ff}
  .vt-scope input,.vt-scope select,.vt-scope textarea,.vt-scope button{font-family:inherit}
  .vt-scope input::placeholder,.vt-scope textarea::placeholder{color:#5c6577}
  .vt-scope button,.vt-scope a{-webkit-tap-highlight-color:transparent}
  .vt-scope button:focus,.vt-scope a:focus,.vt-scope input:focus,.vt-scope select:focus,.vt-scope textarea:focus{outline:none}
  .vt-scope button:focus-visible,.vt-scope a:focus-visible,.vt-scope input:focus-visible,.vt-scope select:focus-visible,.vt-scope textarea:focus-visible{outline:2px solid #4d8dff;outline-offset:3px;border-radius:inherit}
  .vt-scope [data-reveal]{opacity:0;transform:translateY(34px);transition:opacity 1s cubic-bezier(.16,1,.3,1),transform 1s cubic-bezier(.16,1,.3,1);will-change:opacity,transform}
  .vt-scope [data-reveal].rv{opacity:1;transform:none}
  @keyframes vt-drift1{0%,100%{transform:translate(0,0) scale(1)}50%{transform:translate(60px,-40px) scale(1.15)}}
  @keyframes vt-drift2{0%,100%{transform:translate(0,0) scale(1)}50%{transform:translate(-50px,50px) scale(1.2)}}
  @keyframes vt-marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}
  @keyframes vt-spin{to{transform:rotate(360deg)}}
  @keyframes vt-fade{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}
  @keyframes vt-hatch{to{background-position:34px 0,-34px 0}}
  @keyframes vt-stroke{0%,100%{transform:translateY(-255%)}50%{transform:translateY(255%)}}
  @keyframes vt-scan{0%,100%{opacity:.15}50%{opacity:.5}}
  .vt-hoverable{transition:color .2s,background .2s,border-color .2s,transform .3s cubic-bezier(.16,1,.3,1),box-shadow .35s}
`;

export const GlobalStyles = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.setAttribute('data-vtech', 'true');
    style.textContent = CSS;
    document.head.appendChild(style);

    let link = document.querySelector('link[data-vtech-font]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = FONT_HREF;
      link.setAttribute('data-vtech-font', 'true');
      document.head.appendChild(link);
    }

    return () => {
      style.remove();
    };
  }, []);

  return null;
};